import React from 'react'
import PropTypes from 'prop-types';

import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem } from '~/views'

import style from './style.css'

export default class AccountItem extends React.Component {
  
  static START_EVENT = 'startDevice';

  static PAUSE_EVENT = 'pauseDevice';

  static RESET_EVENT = 'resetDevice';

  static REMOVE_EVENT = 'removeDevice';

  static OPEN_LOG_EVENT = 'openDeviceLog';

  static SIM_CONTROL_EVENT = 'openSimControl';

  static DUPLICATE_DEVICE_EVENT = 'duplicateDevice';

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { item } = this.props;
    console.log( item, this.props )
    return (
      <ListItem className={style.AccountItem} 
        onEvent={this.props.onEvent}
        item={item}
        selected={this.props.selected}
        title={item.username}
        subtitle={(
          <div style={{ paddingLeft : '10px' }}>
            {item.email || ''} 
            {' '}
            {item.name || ''}
          </div>
        )}
        leftView={this.renderLeft( item )}
        rightView={this.renderRight( item )} />
    )
  }

  renderLeft( device ) {
    return <i className=" fa fa-user fa-fw" />;
  }

  renderRight( device ) {
    let control, status, options;
    control = (
      <Button bsStyle="link"
        bsSize="large"
        className={style.reset} 
        onClick={() => { this.onEvent( AccountItem.SIM_CONTROL_EVENT ) }}> 
        <i className="fa fa-sliders" /> 
      </Button>
    );

    const duplicate = ( 
      <MenuItem bsStyle="link"
        bsSize="large"
        className={style.deviceButton} 
        onClick={() => { this.onEvent( AccountItem.DUPLICATE_DEVICE_EVENT ) }}> 
        <i className="fa fa-clone fa-fw" />
        {' '}
        Duplicate 
      </MenuItem>
    )
    const remove = ( 
      <MenuItem bsStyle="link"
        bsSize="large"
        className={style.deviceButton} 
        onClick={() => { this.onEvent( AccountItem.REMOVE_EVENT ) }}> 
        <i className="fa fa-times fa-fw" />
        {' '}
        Delete 
      </MenuItem>
    )
    const simulated = device.simNetworkId != null

    if ( simulated ) {
        
      const pause = (
        <MenuItem bsStyle="link"
          bsSize="large"
          className={style.pause} 
          onClick={() => { this.onEvent( AccountItem.PAUSE_EVENT ) }}> 
          <i className="fa fa-pause fa-fw" />
          {' '}
          Pause
        </MenuItem>
      )
      const start = (
        <MenuItem bsStyle="link"
          bsSize="large"
          className={style.pause} 
          onClick={() => { this.onEvent( AccountItem.START_EVENT ) }}> 
          <i className="fa fa-play fa-fw" />
          {' '}
          Start
        </MenuItem>
      )
      const reset = (
        <MenuItem bsStyle="link"
          bsSize="large"
          className={style.reset} 
          onClick={() => { this.onEvent( AccountItem.RESET_EVENT ) }}> 
          <i className="fa fa-repeat fa-fw" />
          {' '}
          Reset
        </MenuItem>
      );
        // log = (
        //   <Button bsStyle="link" bsSize="large" className={style.reset} 
        //      onClick={()=>{this.onEvent( AccountItem.OPEN_LOG_EVENT )}} > 
        //     <i className="fa fa-file-text-o"></i> 
        //   </Button> );
        
      options = (
        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={device.id} id={`options-${device.id}`}>
          {start}
          {pause}
          {reset}
          <MenuItem divider />
          {duplicate}
          <MenuItem divider />
          {remove}
        </DropdownButton>
      )
    } else {
      options = (
        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={device.id} id={`options-${device.id}`}>
          {remove}
        </DropdownButton>
      )
      /*
      options = ( 
          <Button bsStyle="link" bsSize="large" className={style.deviceButton} 
                onClick={()=>{this.onEvent( AccountItem.REMOVE_EVENT )}} > 
            <i className="fa fa-times fa-fw"></i> 
          </Button>)
          */
    }
    return (
      <div>
        {control}
        {options}    
      </div>
    )
  }

}
